import {
    useEffect,
    useState
} from 'react';

import {
    getTopVideos,
    insertTopVideo,
    updateTopVideoTitle,
    deleteTopVideo
} from '../../../api/adminApi';

import './AppTopVideoManage.css';

interface TopVideo {

    id: number;

    title: string;

    imageUrl: string;

    youtubeUrl: string;
}

const extractVideoId = (url: string) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
};

const buildThumbnailUrl = (url: string, useHighRes: boolean = false) => {
    const videoId = extractVideoId(url);
    if (!videoId) return '';
    return `https://img.youtube.com/vi/${videoId}/${useHighRes ? 'maxresdefault.jpg' : 'hqdefault.jpg'}`;
};

const AppTopVideoManage = () => {

    const [videos, setVideos] =
        useState<TopVideo[]>([]);

    const [youtubeUrl, setYoutubeUrl] =
        useState('');

    const [showModal, setShowModal] =
        useState(false);

    const [editId, setEditId] =
        useState<number | null>(null);

    const [editTitle, setEditTitle] =
        useState('');

    const [useHighRes, setUseHighRes] =
        useState(false);

    useEffect(() => {

        loadVideos();

    }, []);

    const loadVideos = async () => {

        const response =
            await getTopVideos();

        setVideos(
            response.data
        );
    };

    const handleInsert = async () => {

        if (!youtubeUrl) {

            alert(
                '유튜브 URL을 입력하세요.'
            );

            return;
        }

        await insertTopVideo({

            youtubeUrl
        });

        setYoutubeUrl('');

        loadVideos();
    };

    const handleDelete = async (
        id: number
    ) => {

        const ok =
            window.confirm(
                '삭제하시겠습니까?'
            );

        if (!ok) {

            return;
        }

        await deleteTopVideo(id);

        loadVideos();
    };

    const handleOpenEdit = (
        video: TopVideo
    ) => {

        setEditId(
            video.id
        );

        setEditTitle(
            video.title
        );

        setShowModal(
            true
        );
    };

    const handleSaveTitle =
        async () => {

            if (!editId) {

                return;
            }

            await updateTopVideoTitle(
                editId,
                editTitle
            );

            setShowModal(
                false
            );

            setEditId(
                null
            );

            setEditTitle(
                ''
            );

            loadVideos();
        };

    return (
        <div className="top-video-manage">

            <h2>
                앱 상단 관리
            </h2>

            <div className="top-video-form">

                <input
                    type="text"
                    placeholder="유튜브 URL 입력"
                    value={youtubeUrl}
                    onChange={(e) =>
                        setYoutubeUrl(
                            e.target.value
                        )
                    }
                />

                <button
                    onClick={
                        handleInsert
                    }
                >
                    등록
                </button>

            </div>

            <div className="top-video-toggles">

                <label className="toggle-label">

                    <input
                        type="checkbox"
                        checked={useHighRes}
                        onChange={(e) =>
                            setUseHighRes(
                                e.target.checked
                            )
                        }
                    />

                    고해상도 썸네일 사용

                </label>

            </div>

            <div className="top-video-list">

                {

                    videos.map(video => (
                        <div
                            key={video.id}
                            className="top-video-card"
                        >

                            <img
                                src={
                                    buildThumbnailUrl(
                                        video.youtubeUrl,
                                        useHighRes
                                    )
                                }
                                alt={
                                    video.title
                                }
                            />

                            <div
                                className="top-video-info"
                            >

                                <h4>
                                    {video.title}
                                </h4>

                                <a
                                    href={
                                        video.youtubeUrl
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    영상 보기
                                </a>

                            </div>

                            <div
                                className="top-video-buttons"
                            >
                                <button
                                    className="edit-btn"
                                    onClick={() =>
                                        handleOpenEdit(
                                            video
                                        )
                                    }
                                >
                                    수정
                                </button>

                                <button
                                    className="delete-btn"
                                    onClick={() =>
                                        handleDelete(
                                            video.id
                                        )
                                    }
                                >
                                    삭제
                                </button>

                            </div>

                        </div>
                    ))
                }

            </div>

            {

                showModal && (

                    <div
                        className="modal-overlay"
                    >

                        <div
                            className="modal-box"
                        >

                            <h3>
                                제목 수정
                            </h3>

                            <input
                                value={
                                    editTitle
                                }
                                onChange={(e) =>
                                    setEditTitle(
                                        e.target.value
                                    )
                                }
                            />

                            <div
                                className="modal-buttons"
                            >

                                <button
                                    className="edit-btn"
                                    onClick={
                                        handleSaveTitle
                                    }
                                >
                                    저장
                                </button>

                                <button
                                    className="delete-btn"
                                    onClick={() =>
                                        setShowModal(
                                            false
                                        )
                                    }
                                >
                                    취소
                                </button>

                            </div>

                        </div>
                    </div>
                )
            }

        </div>
    );
};

export default AppTopVideoManage;
